var scope_0 = require('/opt/build/repo/starters/gatsby-starter-elegantstack-docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/af0690939a3ea66402bfdb0ed3cf88e6.js').default;
var scope_1 = require('/opt/build/repo/starters/gatsby-starter-elegantstack-docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/bc05cd3f6c99c2fbd6185c21d0523a5f.js').default;
var scope_2 = require('/opt/build/repo/starters/gatsby-starter-elegantstack-docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e3967be09808cd53e361a1e69c23e216.js').default;
var scope_3 = require('/opt/build/repo/starters/gatsby-starter-elegantstack-docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3 )
    